export const COMPLETION_MESSAGE_MAX_LENGTH = 2000;

export type CompletionMessages = {
  completionMessageEt: string;
  completionMessageEn: string;
  completionMessageRu: string;
};

/**
 * Starting text for the admin "new configuration" form. Migration 0019 fills
 * existing rows with the same e-service text; keep the two in sync.
 */
export const DEFAULT_COMPLETION_MESSAGES: CompletionMessages = {
  completionMessageEt:
    'Taotluse lõpetamiseks logige uuesti Transpordiameti e-teenindusse ja kinnitage oma taotluse lõpetamine!\nKui taotlust ei lõpetata enne päeva lõppu, tühistatakse see automaatselt samal päeval kell 23:59.',
  completionMessageEn:
    'To finish your application, log in to the Transport Administration e-service again and confirm it!\nIf the application is not finished by the end of the day, it is cancelled automatically at 23:59 the same day.',
  completionMessageRu:
    'Чтобы завершить заявление, снова войдите в э-услуги Транспортного департамента и подтвердите его!\nЕсли заявление не будет завершено до конца дня, оно будет автоматически аннулировано в тот же день в 23:59.',
};

/** Text for the capture success screen in the active locale. */
export function completionMessageForLocale(config: CompletionMessages, locale: string): string {
  switch (locale) {
    case 'en':
      return config.completionMessageEn;
    case 'ru':
      return config.completionMessageRu;
    default:
      return config.completionMessageEt;
  }
}
